import React from 'react';
import Emoji from '../Reusable/Emoji';

import './admin.scss';

import CreateEntry from './CreateEntry';
import List from './List';
import Graph from './Graph';
import { useAppContext } from '../../context/AppContext';

const Admin = () => {
  const { state, actions } = useAppContext();
  const { pictures, labels, username, perPage, totalPages, labelsStats, likesStats } = state;

  return (
    <>
      <div className="admin">
        <div className="admin-header">
          <div className="title">
            <h2>Dear {username}</h2>
            <p>Welcome on board <Emoji emoji='airplane' set='google' size={24} /></p>
          </div>
          <button type="button" className="logout-btn" onClick={actions.logout}>
            Log out
          </button>
        </div>
        <div className="admin-content">
          <Graph labelsStats={labelsStats} likesStats={likesStats} />
          <CreateEntry labels={labels} onSubmit={actions.addPicture} onReadExif={actions.readUploadExif} />
          <List
            pictures={pictures}
            labels={labels}
            perPage={perPage}
            totalPages={totalPages}
            handleStarred={actions.toggleStarred}
            handlePublication={actions.togglePublication}
            onDelete={actions.deletePicture}
            onModify={actions.modifyPicture}
          />
        </div>
      </div>
    </>
  );
};

export default Admin;
